import { Component } from '@angular/core';
import { BaseBPWizardFormComponent, PROFILE_ATTRIBUTES_FORM } from '../base-bp-wizard-form.component';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { FormattingService } from '../../../../shared/services/formatting.service';
import { StateService, TransitionService } from '@uirouter/angular';
import { BPWizardService } from '../bp-wizard.service';
import { BPProfilesService } from '../../bp-profiles.service';
import { BPProfilesDataService } from '../../bp-profiles-data.service';
import { GaValidateService } from '../../../../shared/formly/ga-validate.service';
import { BPProfilesTCDataService } from '../../advanced/tc/bp-profiles-tc-data.service';
import { TextComponent } from '../../../../shared/text/text.component';
import { IValueObject } from '../../../../../type_definitions/datatypes';

@Component({
  selector: 'bp-wizard-billing-methods',
  template: `
    <h2 [class.step-complete]="stepComplete"><text key="HEADING"></text></h2>
    <formly [form]="form" [model]="model" [fields]="fields"></formly>
  `
})
export class BPWizardBillingMethodsComponent extends BaseBPWizardFormComponent {
  constructor(
    private formlyService:GaFormlyService,
    private formattingService:FormattingService,
    transitionService:TransitionService,
    bpWizardService:BPWizardService,
    bpProfilesService:BPProfilesService,
    bpProfilesDataService:BPProfilesDataService,
    validateService:GaValidateService,
    stateService:StateService,
    bpProfilesTCDataService:BPProfilesTCDataService
  ) {
    super(transitionService, bpWizardService, bpProfilesService, bpProfilesDataService, validateService, stateService, bpProfilesTCDataService);
    // marked as TC form
    this.formType = PROFILE_ATTRIBUTES_FORM;
  }

  protected createFields():IExtraFieldConfigurationObject[] {
    // update default value properties
    this.labelClass = 'col-sm-4 col-md-4';
    this.valueClass = 'col-sm-6 col-md-6';

    return [
      this.formlyService.aCustom()
        .withoutWrapper()
        .withComponent(TextComponent)
        .withWrapperClass('col-12 margin-bottom-md')
        .withExtraOptions({
          templateOptions: {
            inputs: {
              key: 'BILLINGMETHODS'
            }
          }
        })
        .build(),
      this.formlyService.aRadio('invoiceCurrencyEUR')
        .withWrapperClass('col-12')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withFormat(this.formattingService.formatLov)
        .withOptions(<IValueObject[]>this.formlyService.getBooleanOptions())
        .withInline()
        .build(),
      this.formlyService.aRadio('invoiceCurrencyUSD')
        .withWrapperClass('col-12')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withFormat(this.formattingService.formatLov)
        .withOptions(<IValueObject[]>this.formlyService.getBooleanOptions())
        .withInline()
        .build(),
      this.formlyService.aCustom()
        .withoutWrapper()
        .withComponent(TextComponent)
        .withWrapperClass('col-12 margin-bottom-md')
        .withExtraOptions({
          templateOptions: {
            inputs: {
              key: 'NOTE'
            }
          }
        })
        .build()
    ];
  }
}